import { render } from "./AlterWall232Component.vue?vue&type=template&id=c0e71fe6&scoped=true"
import script from "./AlterWall232Component.vue?vue&type=script&lang=js"
export * from "./AlterWall232Component.vue?vue&type=script&lang=js"

import "./AlterWall232Component.vue?vue&type=style&index=0&id=c0e71fe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e71fe6"]])

export default __exports__